<lib-page-layout>
  <lib-title-navbar pageHeader title="Panel Admina"></lib-title-navbar>
  <div class="admin-container">
    <div class="admin-grid">
      <div
        class="admin-card"
        [class.admin-card--expanded]="usersExpanded()"
        (click)="usersExpanded.set(!usersExpanded())">
        <div class="admin-card__icon admin-card__icon--users">
          <or-icon name="profile" size="l" class="or-color-white" />
        </div>
        <div class="admin-card__content">
          <div class="admin-card__title">Użytkownicy</div>
        </div>
        <div
          class="admin-card__arrow admin-card__arrow--expand"
          [class.admin-card__arrow--expanded]="usersExpanded()"></div>
      </div>

      @if (usersExpanded()) {
        <div class="admin-submenu">
          <div class="admin-submenu__item" (click)="goToUsers()">
            <span class="admin-submenu__label">Lista</span>
          </div>
          <div class="admin-submenu__item" (click)="goToUsersStats()">
            <span class="admin-submenu__label">Statystyki</span>
          </div>
        </div>
      }

      <div
        class="admin-card"
        [class.admin-card--expanded]="gamesExpanded()"
        (click)="gamesExpanded.set(!gamesExpanded())">
        <div class="admin-card__icon admin-card__icon--games">
          <or-icon name="games" size="l" class="or-color-white" />
        </div>
        <div class="admin-card__content">
          <div class="admin-card__title">Gierki</div>
        </div>
        <div
          class="admin-card__arrow admin-card__arrow--expand"
          [class.admin-card__arrow--expanded]="gamesExpanded()"></div>
      </div>

      @if (gamesExpanded()) {
        <div class="admin-submenu">
          <div class="admin-submenu__item" (click)="goToGames()">
            <span class="admin-submenu__label">Lista</span>
          </div>
          <div class="admin-submenu__item" (click)="goToGamesStats()">
            <span class="admin-submenu__label">Statystyki</span>
          </div>
        </div>
      }

      <div class="admin-card" (click)="goToGeneratePost()">
        <div class="admin-card__icon admin-card__icon--posts">
          <or-icon name="copy-link" size="l" class="or-color-white" />
        </div>
        <div class="admin-card__content">
          <div class="admin-card__title">Generuj posty</div>
        </div>
        <div class="admin-card__arrow"></div>
      </div>

      <div class="admin-card" (click)="goToFeatureFlags()">
        <div class="admin-card__icon admin-card__icon--flags">
          <or-icon name="change-password" size="l" class="or-color-white" />
        </div>
        <div class="admin-card__content">
          <div class="admin-card__title">Feature Flags</div>
        </div>
        <div class="admin-card__arrow"></div>
      </div>

      <div class="admin-card" (click)="goToVersionInfo()">
        <div class="admin-card__icon admin-card__icon--version">
          <or-icon name="settings" size="l" class="or-color-white" />
        </div>
        <div class="admin-card__content">
          <div class="admin-card__title">Informacje o wersji</div>
        </div>
        <div class="admin-card__arrow"></div>
      </div>
    </div>
  </div>
</lib-page-layout>
